export default __webpack_public_path__ + "static/media/bannerBottom.3b85a346.jpg";